import React from "react";
import { Select, SelectItem, TextInput } from "carbon-components-react";

import { CIC_CODE_OPTIONS } from "underwriter_dashboard/hurdle_editors/Fees/shared";

interface ChangeInCircumstanceSelectorProps {
  showOtherCICInput: boolean;
  selectedCIC: string;
  updateSelectedCIC: Function;
  updateShowOtherCICInput: Function;
  updateOtherCICDescription: Function;
  otherCICDescription: string;
}

const CICSelector: React.FC<ChangeInCircumstanceSelectorProps> = ({
  showOtherCICInput,
  selectedCIC,
  updateSelectedCIC,
  updateShowOtherCICInput,
  updateOtherCICDescription,
  otherCICDescription,
}) => {
  return (
    <div style={{ maxWidth: "23rem" }}>
      <Select
        labelText="Change in Circumstance"
        style={{ marginBottom: "10px", width: "23rem", maxWidth: "23rem" }}
        name="cic-selector"
        id="cic-selector"
        value={showOtherCICInput ? "Other" : selectedCIC}
        onChange={e => {
          // If user chooses a pre-existing option, handle the change
          if (e.target.value !== "Other") {
            updateSelectedCIC(e.target.value);
            updateOtherCICDescription("");
            updateShowOtherCICInput(false);
          } else {
            // Clear the selectedCIC, in case user selects another option before selecting the "Other"
            updateSelectedCIC("Other");
            // Otherwise, show the other-cic textbox
            updateShowOtherCICInput(true);
          }
        }}
      >
        <SelectItem key="Select a CIC" text="Select a CIC" value="" />
        {CIC_CODE_OPTIONS.map(cic => (
          <SelectItem key={cic.value} text={cic.label} value={cic.value} />
        ))}
      </Select>

      {showOtherCICInput && (
        <TextInput
          id="other-cic"
          name="other-cic"
          value={otherCICDescription}
          labelText=""
          placeholder="Some other CIC..."
          type="text"
          onChange={e => updateOtherCICDescription(e.target.value)}
          size="sm"
        />
      )}
    </div>
  );
};

export default CICSelector;
